export default __webpack_public_path__ + "static/media/polygon.da7b877d.svg";